import React from 'react';
import { countdownBadgeStyle, countdownBadgeStyleOverLay } from './styles';
import { formatCountdown } from './utils';
import { MCButton, MCText, View } from 'components/basic';
import { BASE_ICONS } from 'components/svg';

// Small pill showing the countdown to a file's deleteAt.
// Unlike FileDetail's name/size, this is NOT gated behind `showFileName` —
// it always shows whenever the file has a deleteAt and hasn't expired yet.
function CountDownBadge({ remainingMs, showIcon, isOverplay }) {
  if (remainingMs == null && showIcon)
    return (
      <View style={{ ...countdownBadgeStyle, ...(isOverplay ? countdownBadgeStyleOverLay : {}) }}>
        <MCButton iconname={BASE_ICONS.CLOCK} fill={'white'} width={16} padding={1} />
      </View>
    );
  if (remainingMs == null) return null;

  return (
    <View style={{ ...countdownBadgeStyle, ...(isOverplay ? countdownBadgeStyleOverLay : {}) }}>
      <MCButton iconname={BASE_ICONS.CLOCK} fill={'white'} width={16} padding={1} />
      <MCText white weight={400} size={16} numberOfLines={1} lineHeight={16}>
        {formatCountdown(remainingMs)}
      </MCText>
    </View>
  );
}

export default CountDownBadge;
